import { render } from "./QuestionsBankModal.vue?vue&type=template&id=199d9262"
import script from "./QuestionsBankModal.vue?vue&type=script&lang=js"
export * from "./QuestionsBankModal.vue?vue&type=script&lang=js"

import "./QuestionsBankModal.vue?vue&type=style&index=0&id=199d9262&lang=css"
script.render = render

export default script